export const LAUNCH_QUESTIONNAIRE = 'LAUNCH_QUESTIONNAIRE';
export const SUBMIT_QUESTIONNAIRE = 'SUBMIT_QUESTIONNAIRE';
export const STORE_QUESTIONNAIRE_ACTIVITY_ID = 'STORE_QUESTIONNAIRE_ACTIVITY_ID';
const NEXT_QUESTION = 'NEXT_QUESTION';
const PREVIOUS_QUESTION = 'PREVIOUS_QUESTION';
const STORE_ANSWERS = 'STORE_ANSWERS';
const RESET_QUESTIONNAIRE = 'RESET_QUESTIONNAIRE';
export const GET_LEARNER_CONFIGS = 'GET_LEARNER_CONFIGS';
export const SET_LEARNER_CONFIGS = 'SET_LEARNER_CONFIGS';

const initialState = {
  currentQuestionNumber: 0,
  chosenAnswers: {},
  activityId: 0,
  skipPlacementTest: null
};

export const questionnaireReducer = (questionnaireState = initialState, action = null) => {
  switch (action && action.type) {
    case LAUNCH_QUESTIONNAIRE:
      return questionnaireState;

    case SET_LEARNER_CONFIGS:
      return {
        ...questionnaireState,
        skipPlacementTest: action.payload.skipPlacementTest
      };

    case NEXT_QUESTION:
      return {
        ...questionnaireState,
        currentQuestionNumber: questionnaireState.currentQuestionNumber + 1
      };

    case PREVIOUS_QUESTION:
      return {
        ...questionnaireState,
        currentQuestionNumber: questionnaireState.currentQuestionNumber - 1
      };

    case STORE_ANSWERS:
      let tempChosenAnswers = questionnaireState.chosenAnswers;
      tempChosenAnswers[action.payload.question] = action.payload.answers;
      if (action.payload.followOnQuestion) {
        tempChosenAnswers[action.payload.followOnQuestion] = action.payload.followOnAnswers;
      }
      return {
        ...questionnaireState,
        chosenAnswers: tempChosenAnswers
      };

    case SUBMIT_QUESTIONNAIRE:
      return questionnaireState;

    case STORE_QUESTIONNAIRE_ACTIVITY_ID:
      return {
        ...questionnaireState,
        activityId: action.payload.activityId
      };

    case RESET_QUESTIONNAIRE:
      return initialState;

    default:
      return questionnaireState;
  }
};

export const questionnaireSelectors = {
  getCurrentQuestionNumber: (state) => state.questionnaire.currentQuestionNumber,
  getChosenAnswers: (state) => state.questionnaire.chosenAnswers,
  getActivityId: (state) => state.questionnaire.activityId,
  skipPlacementTest: (state) => state.questionnaire.skipPlacementTest
};

export const questionnaireActions = {
  setLaunchPageViewed: (launchPageWasViewed) => ({ type: LAUNCH_QUESTIONNAIRE }),
  previousQuestionNumber: () => ({ type: PREVIOUS_QUESTION }),
  nextQuestionNumber: () => ({ type: NEXT_QUESTION }),
  storeChosenAnswers: (question, answers, followOnQuestion, followOnAnswers) => ({
    type: STORE_ANSWERS,
    payload: {
      question: question,
      answers: answers,
      followOnQuestion: followOnQuestion,
      followOnAnswers: followOnAnswers
    }
  }),
  submitQuestionnaire: (answerData) => ({ type: SUBMIT_QUESTIONNAIRE, payload: answerData }),
  storeActivityId: (activityId) => ({ type: STORE_QUESTIONNAIRE_ACTIVITY_ID, payload: { activityId } }),
  resetQuestionnaire: () => ({ type: RESET_QUESTIONNAIRE }),
  getLearnerConfigs: () => ({ type: GET_LEARNER_CONFIGS }),
  setLearnerConfigs: (skipPlacementTest) => ({ type: SET_LEARNER_CONFIGS, payload: { skipPlacementTest } })
};



// WEBPACK FOOTER //
// ./src/modules/questionnaire/reducer/questionnaire-reducer.js